// extracted by mini-css-extract-plugin
export default {"section2":"Works_section2__8WOBD","RelatedWorks":"Works_RelatedWorks__9njEt","left_img2":"Works_left_img2__cRe2f","primary-btn":"Works_primary-btn__jMGSm"};